import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import queryString from "query-string";
import { IdleTimerConsumer } from "react-idle-timer";

import activationOptionModalAction from "../../redux/activationOptionModal/action";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import "./style.css";
import api from "../../config/api";
import CustomSwitch from "../../component/CustomSwitch/CustomSwitch";
import GradientButton from "../../component/GradientButton/GradientButton";
import TextInputOutline from "../../component/TextInputOutline/TextInputOutline";
import historyAction from "../../redux/history/action";
import dashboardAction from "../../redux/dashboard/action";
import authAction from "../../redux/auth/action";
import { isNetworkRequestFailedError } from "../../config/helpers";

class Login extends Component {
  state = {
    username: localStorage.getItem("username") || "",
    password: "",
    rememberMe: JSON.parse(localStorage.getItem("rememberMe")),
    usernameError: "",
    passwordError: "",
    isLoading: false,
  };

  componentDidMount() {
    const { history, setHistory, removeUser, user } = this.props;
    setHistory(history);

    if (user) {
      removeUser();
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("IsConsentAccepted");
    }
  }

  login = async (e, idleTimer) => {
    e.preventDefault();
    const { setHistory } = this.props;
    const { username, password, rememberMe } = this.state;
    const { setUser, history, setAlertMessage, setActiveDashboard } =
      this.props;
    const validateResponse = this.validate();
    let profileResponse = {};

    try {
      this.setState({ isLoading: true });

      if (!validateResponse) {
        this.setState({ isLoading: false });
        return;
      }

      this.setState({ isLoading: true, flag: true });

      const activationResponse = await api.getActivationStatus({ username });

      // activationResponse.data.result = {
      //   UserProfileInfo_isActive: false,
      //   PhoneNumber: "3847583475834",
      //   Email: "izaan@example.com",
      // };

      if (activationResponse.data.result) {
        if (!activationResponse.data.result.UserProfileInfo_isActive) {
          this.props.setActivationModal({
            visible: true,
            data: {
              ...activationResponse.data.result,
              MobileNumber: activationResponse.data.result.PhoneNumber,
              UserName: username,
            },
          });
          this.setState({ isLoading: false, password: "" });
          return;
        }
      }

      const response = await api.login({ username, password });

      const promises = [
        api.getCurrentUserRoles({ username }, response.data.token),
        api.getAllRoles(),
      ];

      const responses = await Promise.all(promises);
      const roleResponse = responses[0];
      const allRoles = responses[1];

      response.data.allRoles = allRoles.data.lstUserRoles;

      if (response.data.ErrorMessage)
        throw new Error(response.data.ErrorMessage);

      response.data.profile = {};
      const isMember = roleResponse.data.lstUserRoles.some(
        (item) => item.roleId === 4
      );

      if (isMember) {
        profileResponse = await this.fetchProfile(response.data);

        await this.getAccountOfficerInfo(response.data);

        if (
          profileResponse.data.ErrorMessage &&
          profileResponse.data.ErrorMessage !==
            "Invalid PIN, RSA PIN doesn't exist!"
        )
          throw new Error(profileResponse.data.ErrorMessage);

        response.data.profile =
          (profileResponse.data && profileResponse.data.result) || {};
      }

      const sortedRoles = roleResponse.data.lstUserRoles.sort(
        (a, b) => a.id - b.id
      );

      response.data.roles = sortedRoles;
      response.data.primaryRole = sortedRoles[0];

      setActiveDashboard(sortedRoles[0].roleId);

      localStorage.removeItem("username");
      if (rememberMe) localStorage.setItem("username", username);

      sessionStorage.setItem(
        "user",
        JSON.stringify({ ...response.data, rememberMe })
      );

      const consentResponse = await api.isConsentAccepted(
        { userName: response.data.User.UserName },
        response.data.token
      );

      let consentData = consentResponse.data.result;

      if (!consentData) {
        sessionStorage.setItem("IsConsentAccepted", false);
        history.replace("/consentscreen");
      } else if (consentData) {
        if (history.location.search) {
          const qs = queryString.parse(this.props.location.search);
          history.replace(qs.redirect);
        } else {
          sessionStorage.setItem("IsConsentAccepted", true);

          // Doesn't work without setTimeout
          // Don't know why. Do not remove
          setTimeout(() => {
            history.replace("/");
            setHistory(history);
          }, 100);
        }
      }

      setUser({ ...response.data, rememberMe });
      idleTimer.reset();

      this.setState({ isLoading: false, password: "" });
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.login(e, idleTimer)
          : null,
      });
    }

    this.setState({ isLoading: false, password: "" });
  };

  fetchProfile = (user) =>
    api.fetchProfile({ pin: user.User.rsaPin }, user.token);

  getAccountOfficerInfo = async (data) => {
    try {
      const response = await api.getAccountOfficer(
        { pin: data.User.rsaPin },
        data.token
      );

      this.props.setAccountOfficerInfo(response.data.result);
    } catch (e) {
      throw e;
    }
  };

  validate = () => {
    const { username, password } = this.state;
    let usernameError = "";
    let passwordError = "";

    if (!username.trim().length) usernameError = "Username is required!";
    if (!password.trim().length) passwordError = "Password is required!";

    this.setState({ usernameError, passwordError });
    return !(usernameError || passwordError);
  };

  handleToggleSwitch = (rememberMe) => {
    localStorage.setItem("rememberMe", rememberMe);
    this.setState({ rememberMe });
  };

  render() {
    const {
      username,
      password,
      rememberMe,
      usernameError,
      passwordError,
      isLoading,
    } = this.state;

    return (
      <IdleTimerConsumer>
        {(idleTimer) => (
          <div className="login-main-container">
            <Container>
              <div className="login-container">
                <img
                  alt="app-icon"
                  src={require("../../assets/icons/app-icon.png")}
                />
                <p className="login-container-app-name">
                  Premium Pension Limited
                </p>
                <form
                  className="my-5 login-input-container"
                  onSubmit={(e) => this.login(e, idleTimer)}
                >
                  <TextInputOutline
                    onChange={(e) =>
                      this.setState({
                        username: e.target.value,
                        usernameError: "",
                      })
                    }
                    value={username}
                    label="Username"
                    errorMessage={usernameError}
                  />
                  <TextInputOutline
                    type="password"
                    containerClasses="mt-4"
                    label="Password"
                    value={password}
                    onChange={(e) =>
                      this.setState({
                        password: e.target.value,
                        passwordError: "",
                      })
                    }
                    errorMessage={passwordError}
                  />
                  <div className="login-forgot-container my-2">
                    <CustomSwitch
                      onChange={this.handleToggleSwitch}
                      checked={rememberMe}
                      containerClasses="my-1 flex1"
                    />
                    <Link className="forgot-password-text" to="/forgotpassword">
                      <p className="text-center">Forget Password</p>
                    </Link>
                    {/* <p>Forget Password</p> */}
                  </div>
                  <GradientButton
                    type="submit"
                    containerClasses="mt-5"
                    label="Login"
                  />
                  <Link className="login-link" to="/register">
                    <p>Don't have an account? Register</p>
                  </Link>
                </form>
              </div>
              <div className="text-center">
                <a
                  rel="noopener noreferrer"
                  href="https://ng.linkedin.com/company/premium-pension-limited"
                  target="_blank"
                >
                  <img
                    alt="linkedin-icon"
                    src={require("../../assets/icons/linkedin.svg")}
                    className="social-icons"
                  />
                </a>
                <a
                  rel="noopener noreferrer"
                  href="https://www.pinterest.co.uk/pin/293930313161646440/"
                  target="_blank"
                >
                  <img
                    alt="pinterest-icon"
                    src={require("../../assets/icons/pinterest.svg")}
                    className="social-icons"
                  />
                </a>
                <a
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/PremiumPension/"
                  target="_blank"
                >
                  <img
                    alt="facebook-icon"
                    src={require("../../assets/icons/facebook.svg")}
                    className="social-icons"
                  />
                </a>
                <a
                  rel="noopener noreferrer"
                  href="https://twitter.com/premiumpension"
                  target="_blank"
                >
                  <img
                    alt="twitter-icon"
                    src={require("../../assets/icons/twitter.svg")}
                    className="social-icons"
                  />
                </a>
                <a
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/premiumpensionltd/"
                  target="_blank"
                >
                  <img
                    alt="instagram-icon"
                    src={require("../../assets/icons/instagram.svg")}
                    className="social-icons"
                  />
                </a>
                <Link
                  className="login-link login-link-bottom"
                  to="/privacypolicy"
                >
                  <p className="text-center">Privacy Policy</p>
                </Link>
              </div>
            </Container>
            {isLoading && <CustomLoader text="Please wait" />}
          </div>
        )}
      </IdleTimerConsumer>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  setUser: authAction.setUser,
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  removeAlertMessage: authAction.removeAlertMessage,
  setActiveDashboard: dashboardAction.setActiveDashboard,
  setAccountOfficerInfo: authAction.setAccountOfficerInfo,
  removeUser: authAction.removeUser,
  setActivationModal: activationOptionModalAction.setActivationModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
